module.exports = __webpack_public_path__ + "static/media/estudio-icon--white.c93576e4.svg";